import React, { useState, useEffect } from "react";
import { Col, Row, DatePicker, Card, Form, Spin, Select } from "antd";
import {
  InfoCircleOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  RiseOutlined,
  StockOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { blue } from "@ant-design/colors";

const DbsSentInvoiceSummary = (props) => {
  const [summaryData, setSummaryData] = useState({
    data: {
      total: props.data.total,
      success: props.data.success,
      error: props.data.error,
      totalAmount: props.data.totalAmount,
      firmBalance: props.firmBalance,
    },
    loading: false,
  });

  useEffect(() => {
    setSummaryData({
      data: {
        total: props.data.total,
        success: props.data.success,
        error: props.data.error,
        totalAmount: props.data.totalAmount,
        firmBalance: props.firmBalance,
      },
      loading: false,
    });
  }, [props]);

  const formatNumber = (number) => {
    number = parseFloat(number);
    let parts = number.toFixed(2).toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(",");
  };

  return (
    <Row id="summaryArea" style={{ ...props.style }}>
      <Col span={24}>
        <Card
          hoverable
          style={{
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            background: "linear-gradient(to right, #e3f2fd, #ffffff)"
          }}
          bodyStyle={{ padding: 13 }}
        >
          <Row justify="center">
            {summaryData.loading ? (
              <Col span={24} style={{ textAlign: "center", marginTop: 20 }}>
                <Spin size="large" />
              </Col>
            ) : (
              <>
                <Col xs={24} md={12} lg={summaryData.data.firmBalance !== null && summaryData.data.firmBalance !== undefined ? 4 : 6} style={{ textAlign: "center" }}>
                  <p>
                    <InfoCircleOutlined
                      style={{
                        color: "blue",
                        fontSize: "200%",
                        backgroundColor: "#d6ebf9",
                        borderRadius: "50%",
                        padding: "10px"
                      }}
                    />
                  </p>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                    <h4 style={{ fontWeight: "bold", color: "#333" }}>Toplam: <span style={{ fontWeight: "500" }}>{summaryData.data.total}</span></h4>
                  </div>
                </Col>

                <Col xs={24} md={12} lg={summaryData.data.firmBalance !== null && summaryData.data.firmBalance !== undefined ? 4 : 6} style={{ textAlign: "center" }}>
                  <p>
                    <CheckCircleOutlined
                      style={{
                        color: "green",
                        fontSize: "200%",
                        backgroundColor: "#E8F5E9",
                        borderRadius: "50%",
                        padding: "10px"
                      }}
                    />
                  </p>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                    <h4 style={{ fontWeight: "bold", color: "#333" }}>Başarılı: <span style={{ fontWeight: "500" }}>{summaryData.data.success}</span></h4>
                  </div>
                </Col>

                <Col xs={24} md={12} lg={summaryData.data.firmBalance !== null && summaryData.data.firmBalance !== undefined ? 4 : 6} style={{ textAlign: "center" }}>
                  <p>
                    <ExclamationCircleOutlined
                      style={{
                        color: "red",
                        fontSize: "200%",
                        backgroundColor: "#FFEBEE",
                        borderRadius: "50%",
                        padding: "10px"
                      }}
                    />
                  </p>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                    <h4 style={{ fontWeight: "bold", color: "#333" }}>Hatalı: <span style={{ fontWeight: "500" }}>{summaryData.data.error}</span></h4>
                  </div>
                </Col>

                <Col xs={24} md={12} lg={summaryData.data.firmBalance !== null && summaryData.data.firmBalance !== undefined ? 4 : 6} style={{ textAlign: "center" }}>
                  <p>
                    <RiseOutlined
                      style={{
                        color: "purple",
                        fontSize: "200%",
                        backgroundColor: "#F3E5F5",
                        borderRadius: "50%",
                        padding: "10px"
                      }}
                    />
                  </p>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                    <h4 style={{ fontWeight: "bold", color: "#333" }}>Tutar: <span style={{ fontWeight: "500" }}>{formatNumber(summaryData.data.totalAmount)}</span></h4>
                  </div>
                </Col>

                {summaryData.data.firmBalance !== null && summaryData.data.firmBalance !== undefined && (
                  <Col xs={24} md={12} lg={4} style={{ textAlign: "center" }}>
                    <p>
                      <StockOutlined
                        style={{
                          color: "blue",
                          fontSize: "200%",
                          backgroundColor: "#E3F2FD",
                          borderRadius: "50%",
                          padding: "10px"
                        }}
                      />
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                      <h4 style={{ fontWeight: "bold", color: "#333" }}>Cari Bakiye: <span style={{ fontWeight: "500" }}>{formatNumber(summaryData.data.firmBalance)}</span></h4>
                    </div>
                  </Col>
                )}

                {summaryData.data.firmBalance !== null && summaryData.data.firmBalance !== undefined && (
                  <Col xs={24} md={12} lg={4} style={{ textAlign: "center" }}>
                    <p>
                      <MinusCircleOutlined
                        style={{
                          color: "green",
                          fontSize: "200%",
                          backgroundColor: "#E8F5E9",
                          borderRadius: "50%",
                          padding: "10px"
                        }}
                      />
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                      <h4 style={{ fontWeight: "bold", color: "#333" }}>Fark: <span style={{ fontWeight: "500" }}>{formatNumber( summaryData.data.totalAmount - summaryData.data.firmBalance)}</span></h4>
                    </div>
                  </Col>
                )}
              </>
            )}
          </Row>
        </Card>

      </Col>
    </Row>
  );
};
export default DbsSentInvoiceSummary;
